import './Footer.scss';

import React from 'react';

export function Footer(): JSX.Element {
    return (
        <footer className="footer">
            <div className="footer__content">
                Oleg,<br />
                <a href="mailto:oleg.litovski9@gmail.com">oleg.litovski9@gmail.com</a> <br />
                <a href="https://github.com/Nodlik">Github</a>
            </div>
        </footer>
    );
}
